/* Iron & Oak — client-side SAVE % badge injection.
   Runs when the theme's server-side badge output is stale/empty.
   Reads product data from /products/{handle}.js and populates empty .card__badge divs. */
(function () {
  'use strict';

  var cache = new Map();

  function fetchProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    var p = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    cache.set(handle, p);
    return p;
  }

  function ensureBadge(card, product) {
    if (!product) return;
    var comparePrice = product.compare_at_price_max || product.compare_at_price || 0;
    var price = product.price || 0;
    if (!comparePrice || comparePrice <= price) return;
    var pct = Math.floor(((comparePrice - price) * 100) / comparePrice);
    if (pct <= 0) return;

    var badgeContainer = card.querySelector('.card__badge');
    if (!badgeContainer) return;
    // Skip if already populated (e.g. server rendered it)
    if (badgeContainer.querySelector('span, .badge')) return;

    var span = document.createElement('span');
    span.className = 'badge badge--bottom-left';
    span.setAttribute('data-source', 'js-save-badge');
    span.textContent = 'SAVE ' + pct + '%';
    badgeContainer.appendChild(span);
  }

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  // Hide any strikethrough "regular price" element that displays zero — happens
  // when a variant has compare_at_price=0 and Dawn renders the range min.
  function hideZeroCompareAt(root) {
    var scope = root || document;
    var selectors = [
      '.price-item--regular',
      '.price__regular .price-item',
      '.price__sale s',
      '.card-wrapper s.price-item',
      '.card-wrapper .price s'
    ];
    scope.querySelectorAll(selectors.join(',')).forEach(function (el) {
      var text = (el.textContent || '').trim();
      // Match "€0", "€0,00", "€0.00", "0.00 EUR", etc. — number is zero in any format
      if (/^[^\d]*0([.,]0+)?[^\d]*$/.test(text)) {
        el.style.display = 'none';
      }
    });
  }

  function process() {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      if (card.__ironoakBadgeProcessed) return;
      card.__ironoakBadgeProcessed = true;
      var handle = handleFromCard(card);
      if (!handle) return;
      fetchProduct(handle).then(function (product) {
        ensureBadge(card, product);
      });
    });
    hideZeroCompareAt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', process);
  } else {
    process();
  }

  // Re-run on section render events (AJAX cart, filters, etc.)
  document.addEventListener('shopify:section:load', process);
  document.addEventListener('shopify:section:reorder', process);

  // Also react to variant switches (PDP price re-renders) by watching for
  // additions to the DOM and re-running the zero-price cleanup.
  var observer = new MutationObserver(function () { hideZeroCompareAt(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
